import React from 'react'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBook } from '@fortawesome/pro-solid-svg-icons'

import { DC3_CONFIGURATION_GUIDE_URL } from 'config/dc3'

import { AboutButton } from './styled'

const NormativeCoursesAboutButton: React.FC = () => {
  const { t } = useTranslation()

  const handleClick = () => {
    window.open(DC3_CONFIGURATION_GUIDE_URL, '_blank', 'noopener,noreferrer')
  }

  return (
    <AboutButton type="button" onClick={handleClick}>
      <FontAwesomeIcon icon={faBook} aria-hidden />
      {t('administration.courses.list.aboutNormativeCourses')}
    </AboutButton>
  )
}

export default NormativeCoursesAboutButton
